import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import { FormValidator } from "../../../helpers/FormValidator";
// import { ZoneList } from "../../../helpers/ZoneList";
import { GetCurrentZone } from "../../../helpers/CurrentTimeZone";
import { Editor } from "@tinymce/tinymce-react";
import $ from "jquery";
import Dropzone from "react-dropzone";

import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
} from "react-places-autocomplete";

import Select from "react-select";
import MultiSelecter from "../../../components/Multiselect/MultiSelecter";
import auth from "../../../helpers/auth";

export class AddListingsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errClass: "",
      address: "",
      insuranceCertificate: "",
      businessCertificate: "",
      termAndCondtions: false,
      googleAPIReady:false
    };
    this.handleChange = this.handleChange.bind(this);
    this.editorHandleChange = this.editorHandleChange.bind(this);
    this.handleLocation = this.handleLocation.bind(this);
    this.handleMultiSelect = this.handleMultiSelect.bind(this);
    this.handleLocationSelect = this.handleLocationSelect.bind(this);
    this.showPreview = this.showPreview.bind(this);
    this.handleImg = this.handleImg.bind(this);
    this.handleAttachment = this.handleAttachment.bind(this);
    this.submitData = this.submitData.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.removeGallery = this.removeGallery.bind(this);
    if (auth.isAuthenticated) {
      this.props.history.push("/");
    }
  }

  componentDidMount() {
    let body = document.body;
    body.className = "add_your_listings";
    // var script = document.createElement("script");

    this.props.fetchCategory();
    this.props.fetchLables();
    // this.props.fetchRegions();
    this.props.fetchCountry();
    this.props.fetchTimeZones()
    // var script = document.createElement("script");
    // script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&libraries=places`;
    // script.async = true;
    // document.head.appendChild(script);

    // @@ nee comment
    let { listingData } = this.props.AddListingState;
    // console.log('listingDatalistingData', listingData, window.location.hash)
    // console.log(this.props.AddListingState,this.props.AddListingState)
    // if (!window.location.hash) {
    //   window.location = window.location + "#loaded";
    //   listingData && !listingData.location && window.location.reload();
    // }
    this.handleLoaded();
    // this.updateCurrentTimeZone();
  }


  handleLoaded() {
     // Load the Google Maps script if it's not already available
    //  if (!window.google) {
      const script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyDsKhasKdWg0EAsycG_0u0Z5pVAkAGXl7c&libraries=places';
      script.async = true;  // Ensure it loads asynchronously
      script.defer = true;  // Ensure it doesn't block other resources
      script.onload = () => {
        this.setState({ googleAPIReady: true });
      };
      script.onerror = () => {
        console.error('Error loading Google Maps API');
      };
      document.body.appendChild(script);
    // } else {
    //   // If API is already available, just set the flag
    //   this.setState({ googleAPIReady: true });
    // }
  }

  // @@ update current time zone if time zone not available
  // updateCurrentTimeZone(){
  //   let { listingData } = this.props.AddListingState;
  //   if(!listingData.timezone){
  //     const curr_zone=GetCurrentZone()
  //     listingData["timezone"] = curr_zone;
  //     this.props.setAddListingData(listingData);
  //   }
  // }
  handleLocation(value) {
    console.log('valuevalue', value)
    let { listingData } = this.props.AddListingState;
    listingData["location"] = value;
    listingData["lattitude"] = null;
    listingData["longitude"] = null;
    this.props.setAddListingData(listingData);
  }

  async handleLocationSelect(address) {
    let { listingData } = this.props.AddListingState;
    // const addressName = address.formatted_address;
    // const lng = address.geometry.location.lng();
    // const lat = address.geometry.location.lat();

    const results = await geocodeByAddress(address);
    const latLng = await getLatLng(results[0]);
    listingData["lattitude"] = latLng.lat;
    listingData["longitude"] = latLng.lng;
    listingData["location"] = address;
    // listingData['lattitude'] = lat;
    // listingData['longitude'] = lng;
    // listingData['location'] = addressName;
    this.props.setAddListingData(listingData);
  }

  async handleImg(event) {
    let { listingData } = this.props.AddListingState;
    let name = event.target.name;
    let { files } = event.target;
    if (!files[0].name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
      $("input[name='" + name + "']").val("");
      this.props.setSiteAlertMessage({
        message: "The Image type must be JPEG, JPG, PNG",
        color: "teal",
      });

      listingData[name] = null;
      this.props.setAddListingData(listingData);
    } else if (files[0].size > 8000000) {
      $("input[name='" + name + "']").val("");
      this.props.setSiteAlertMessage({
        message: "The Image size must be less than 8 MB",
        color: "teal",
      });

      listingData[name] = null;
      this.props.setAddListingData(listingData);
      //---> Disappearing the Alert Message after 3 sec
    } else {
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        listingData[name] = e.target.result;
        this.props.setAddListingData(listingData);
      };
    }
    setTimeout(() => {
      this.props.setSiteAlertMessage({
        message: "",
        color: "",
      });
    }, 5000);
  }

  handleAttachment(event) {
    let { listingData } = this.props.AddListingState;
    let name = event.target.name;
    let { files } = event.target;
    if (!files[0].name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
      if (files[0].name.match(/\.(pdf|PDF|docx|DOCX|doc|DOC)$/)) {
        if (files[0].size > 8000000) {
          $("input[name='" + name + "']").val("");
          this.props.setSiteAlertMessage({
            message: "File size must be less than 8 MB",
            color: "teal",
          });

          listingData[name] = null;
          this.props.setAddListingData(listingData);
          //---> Disappearing the Alert Message after 3 sec
        } else {
          if (name == "insurance_certificate") {
            this.setState({ insuranceCertificate: event.target.files[0] });
          } else {
            this.setState({ businessCertificate: event.target.files[0] });
          }
        }
      } else {
        $("input[name='" + name + "']").val("");
        this.props.setSiteAlertMessage({
          message: "Please select image, pdf or docx file",
          color: "teal",
        });

        listingData[name] = null;
        this.props.setAddListingData(listingData);
      }
    } else if (files[0].size > 8000000) {
      $("input[name='" + name + "']").val("");
      this.props.setSiteAlertMessage({
        message: "The Image size must be less than 8 MB",
        color: "teal",
      });

      listingData[name] = null;
      this.props.setAddListingData(listingData);
      //---> Disappearing the Alert Message after 3 sec
    } else {
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        listingData[name] = e.target.result;
        this.props.setAddListingData(listingData);
      };
    }
    setTimeout(() => {
      this.props.setSiteAlertMessage({
        message: "",
        color: "",
      });
    }, 5000);
  }

  handleSelect(selected, event) {
    let { listingData } = this.props.AddListingState;
    if (event.name == "country_id") {
      // listingData['timezone'] = '';
      listingData['listing_region'] = '';
    }
    if (event.name === "listing_region") {
      // listingData['timezone'] = '';
    }

    if (event.name === "country_id") {
      this.props.fetchRegions(selected.value);
      if (selected.iso) {
        this.props.fetchTimeZoneswithCountryCode(selected.iso, this.updateTimezone.bind(this));
      }
    } else if (event.name === "listing_region") {
      this.props.fetchTimeZoneswithStateName(selected.label,this.updateTimezoneWithStateName.bind(this));
    }

    listingData[event.name] = selected.value;

    this.props.setAddListingData(listingData);
  }

  updateTimezone(selected) {
    let { listingData } = this.props.AddListingState;
    listingData["timezone"] = selected ? selected : '';
    this.props.setAddListingData(listingData);
  }

  updateTimezoneWithStateName(selected) {
    let { listingData } = this.props.AddListingState;

    if (selected) {
      listingData["timezone"] = selected;
      this.props.setAddListingData(listingData);
    }

  }

  handleMultiSelect = async (id, selectedList) => {
    let { listingData } = this.props.AddListingState;
    let arr = [];
    selectedList.map((item) => arr.push(item.value));
    listingData[id] = arr;
    this.props.setAddListingData(listingData);
  };

  handleChange(e) {
    let { listingData } = this.props.AddListingState;
    let name = e.target.name;
    let value = e.target.value;
    listingData[name] = value;
    this.props.setAddListingData(listingData);
  }

  removeGallery(img) {
    let {
      listingData,
      listingData: { gallery_images },
    } = this.props.AddListingState;
    gallery_images = gallery_images.filter((i) => i !== img);
    listingData["gallery_images"] = gallery_images;
    this.props.setAddListingData(listingData);
  }

  onDrop(files) {
    let { listingData } = this.props.AddListingState;
    let img_arr = [];
    if (files.length + listingData.gallery_images.length > 6) {
      this.props.setSiteAlertMessage({
        message: "You can only select 6 images.",
        color: "teal",
      });
    } else {
      Object.keys(files).map((item, i) => {
        if (!files[item].name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
          this.props.setSiteAlertMessage({
            message: "The Image type must be JPEG, JPG, PNG",
            color: "teal",
          });
        } else if (files[item].size > 8000000) {
          this.props.setSiteAlertMessage({
            message: "Image size should not be more than 8 MB.",
            color: "teal",
          });
        } else {
          let reader = new FileReader();
          reader.readAsDataURL(files[item]);
          reader.onload = (e) => {
            if (!listingData.gallery_images.includes(e.target.result)) {
              listingData["gallery_images"].push(e.target.result);
            }
            img_arr.push(e.target.result);
          };
        }
      });
      this.props.setAddListingData(listingData);
    }
    setTimeout(() => {
      this.props.setSiteAlertMessage({ message: "", color: "" });
    }, 5000);
  }

  editorHandleChange(value) {
    let { listingData } = this.props.AddListingState;
    listingData["description"] = value;
    this.props.setAddListingData(listingData);
  }

  showPreview(e) {
    e.preventDefault();
    let { termAndCondtions } = this.state;
    let { listingData } = this.props.AddListingState;
    let { err, errClass } = FormValidator(listingData);
    if (!err) {
      if (termAndCondtions) {
        this.props.history.push("/listing-preview");
      } else {
        this.props.setSiteAlertMessage({
          message: "Please select term & conditions.",
          color: "teal",
        });
        this.setState({ errClass: "teal" });
      }
    } else {
      this.props.setSiteAlertMessage({
        message: err.message,
        color: err.color,
      });
      this.setState({ errClass: errClass });
    }

    setTimeout(() => {
      this.props.setSiteAlertMessage({ message: "", color: "" });
      this.setState({ errClass: "" });
    }, 5000);
  }

  submitData(e) {
    e.preventDefault();
    let { listingData } = this.props.AddListingState;
    let { err, errClass } = FormValidator(listingData);
    let { insuranceCertificate, businessCertificate, termAndCondtions } =
      this.state;
    listingData["insuranceCertificate"] = insuranceCertificate;
    listingData["businessCertificate"] = businessCertificate;

    if (!err) {
      if (termAndCondtions) {
        this.props.submitListing({
          ...listingData,
          history: this.props.history,
        });
      } else {
        this.props.setSiteAlertMessage({
          message: "Please select term & conditions.",
          color: "teal",
        });
        this.setState({ errClass: "teal" });
      }
    } else {
      this.props.setSiteAlertMessage({
        message: err.message,
        color: err.color,
      });
      this.setState({ errClass: errClass });
    }
    setTimeout(() => {
      this.props.setSiteAlertMessage({ message: "", color: "" });
      this.setState({ errClass: "" });
    }, 5000);
  }

  render() {
    let {
      listingData,
      addListingSpinner,
      categories,
      lables,
      regions,
      country,
      timeZoneList,
      stateTimeZoneList,
      countryTimeZoneList,
    } = this.props.AddListingState;
    let { errClass, termAndCondtions } = this.state;

    const { googleAPIReady } = this.state;
    // let ZoneList=timeZoneList;
    // listing_region timezone country_id
    let ZoneList = []
    if (listingData.listing_region && listingData.country_id) {
      ZoneList = stateTimeZoneList.length > 0 ? stateTimeZoneList : (countryTimeZoneList.length > 0) ? countryTimeZoneList : timeZoneList
      if (stateTimeZoneList.length > 0) {
        ZoneList = stateTimeZoneList;
      } else if (countryTimeZoneList.length > 0) {
        ZoneList = countryTimeZoneList;
      } else {
        ZoneList = timeZoneList
      }
    } else {
      ZoneList = []
    }

    // If the Google Maps API isn't ready, we don't render PlacesAutocomplete
    if (!googleAPIReady) {
      return <div>Loading Google Maps...</div>;
    }
    return (
      <Fragment>
        <div className="main-content yss-site--main__content">
          <div className="site__content">
            <div className="page__content">
              <div className="form__heading">
                <h3>
                  {/* Add Your <span>Listing</span> */}
                  Add Your <span>Coaching Service</span> 
                </h3>
                <p>
                  Welcome, we are so excited that you are interested in making a
                  positive impact on recovery through Recovery Coaching!
                </p>
                <p>
                  Before you get started, here’s the minimum you will need to
                  get listed. Email, Professional Bio, Cover Image, Portrait
                  Image & a Stripe-Account.
                </p>
              </div>
              <div className="site__form middle__content add-listing--form mb-8">
                <form className="clearfix" onSubmit={(e) => this.submitData(e)}>
                  {!auth.isAuthenticated ? (
                    <div className="form-item form-item--login__required">
                      <span>
                        If you have an account sign in first before updating
                        your listing. If you don't have an account you can
                        create one here by entering your email address/username.
                        Your account details will be confirmed via email.
                      </span>
                      <Link to="/coach/login" className="login-rquired__button">
                        Sign In
                      </Link>
                    </div>
                  ) : null}
                  <div className="form-item">
                    <div className="form-label">Email:</div>
                    <input
                      className={
                        errClass == "email"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="text"
                      name="email"
                      placeholder="you@yourdomain.com"
                      onChange={this.handleChange}
                      value={listingData.email}
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-item">
                    <div className="form-label">Username:</div>
                    <input
                      className={
                        errClass == "username"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="text"
                      name="name"
                      onChange={this.handleChange}
                      value={listingData.name}
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-item">
                    <div className="form-label">Password:</div>
                    <input
                      className={
                        errClass == "password"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="password"
                      name="password"
                      onChange={this.handleChange}
                      value={listingData.password}
                      autoComplete="off"
                      placeholder="Minimum 8 characters including numbers & special characters"
                    />
                  </div>
                  <div className="form-item">
                    <div className="form-label">Confirm Password:</div>
                    <input
                      className={
                        errClass == "c_password"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="password"
                      name="c_password"
                      onChange={this.handleChange}
                      value={listingData.c_password}
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-item">
                    <div className="form-label">Your name:</div>
                    <input
                      className={
                        errClass == "listing_name"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="text"
                      name="listing_name"
                      placeholder="Your name"
                      onChange={this.handleChange}
                      value={listingData.listing_name}
                      autoComplete="off"
                    />
                  </div>
                  {/*<div className="form-item">
                    <div className="form-label">
                      Contact Email/URL : (optional)
                    </div>
                    <input
                      className={
                        errClass == "contact_email_or_url"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="text"
                      name="contact_email_or_url"
                      placeholder="Enter an email address or website url"
                      onChange={this.handleChange}
                      value={listingData.contact_email_or_url}
                      autoComplete="off"
                    />
                    </div>*/}
                  <div className="form-item">
                    <div className="form-label">Description: </div>
                    <Editor
                      apiKey="x84ab9bfprazeycxveeoxsrl7rbgmv5887mhpwjieitv0v9u"
                      value={listingData.description}
                      name="description"
                      init={{
                        height: 300,
                        plugins: "paste",
                        paste_as_text: true,
                        //menubar: 'insert',
                        placeholder:
                          "A little about your experience and the support you are offering",
                        plugins: [
                          "advlist autolink lists link image charmap print preview anchor",
                          "searchreplace visualblocks code fullscreen",
                          "insertdatetime media table paste imagetools",
                        ],
                        toolbar:
                          "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent ",
                      }}
                      onEditorChange={this.editorHandleChange}
                    />
                  </div>

                  {categories ? (
                    <div className="form-item">
                      <label>Listing Category:</label>
                      <Select
                        name={"listing_category"}
                        className="new_select"
                        options={categories}
                        value={categories.filter((option) => {
                          return option.value === listingData.listing_category;
                        })}
                        onChange={this.handleSelect}
                        searchable={true}
                      />
                    </div>
                  ) : null}

                  <div className="form-item">
                    <label>Listing Country:</label>
                    <Select
                      name={"country_id"}
                      className="new_select"
                      options={country}
                      value={country.filter(
                        (option) => option.value === listingData.country_id
                      )}
                      onChange={this.handleSelect}
                      searchable={true}
                    />
                  </div>
                  <div className="form-item">
                    <label>Listing Region/State:</label>
                    <Select
                      name={"listing_region"}
                      className="new_select"
                      options={regions}
                      value={regions.filter((option) => {
                        return option.value === listingData.listing_region;
                      })}
                      onChange={this.handleSelect}
                      searchable={true}
                    />
                  </div>
                  <div className="form-item">
                    <div className="form-label">Map Location :</div>
                    <PlacesAutocomplete
                      // key={process.env.REACT_APP_GOOGLE_MAP_KEY}
                      value={listingData.location}
                      onChange={this.handleLocation}
                      onSelect={this.handleLocationSelect}
                      searchOptions={{
                        // componentRestrictions:{
                        //   country:'US'
                        // }
                      }}
                    >
                      {({
                        getInputProps,
                        getSuggestionItemProps,
                        suggestions,
                        loading,
                      }) => {
                        return (
                          <div className="autocomplete-root">
                            {console.log('suggestions', suggestions)}
                            <input
                              {...getInputProps({
                                placeholder: "Enter the location",
                                className:
                                  errClass === "location"
                                    ? "location-search-input border-red-500"
                                    : "location-search-input border-color-blue",
                              })}
                            />

                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map((suggestion, i) => {
                                const className = suggestion.active
                                  ? "suggestion-item--active"
                                  : "suggestion-item";
                                const style = suggestion.active
                                  ? {
                                    backgroundColor: "#fafafa",
                                    cursor: "pointer",
                                  }
                                  : {
                                    backgroundColor: "#ffffff",
                                    cursor: "pointer",
                                  };
                                return (
                                  <div
                                    key={suggestion.placeId}
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      }}
                    </PlacesAutocomplete>
                    {/* <Autocomplete
                        apiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
                        style={{ width: "90%" }}
                        onPlaceSelected={(place) => {
                          this.handleLocationSelect(place)
                        }}
                        options={{
                          types: ["(regions)"],
                          // componentRestrictions: { country: "in" },
                        }}
                        onChange={(e)=>this.handleLocation(e.target.value)}
                        value={listingData.location}
                      />*/}
                  </div>

                  <div className="form-item">
                    <label>Timezone :</label>

                    <Select
                      name={"timezone"}
                      className="new_select"
                      options={ZoneList}
                      value={ZoneList.filter((option) => {
                        return option.value === listingData.timezone;
                      })}
                      onChange={this.handleSelect}
                      searchable={true}
                    />
                  </div>

                  <div className="form-item">
                    <label>Listing Labels (optional) :</label>

                    <MultiSelecter
                      id="listing_label"
                      Options={lables}
                      displayValue={"label"}
                      fireData={(id, selectedList) =>
                        this.handleMultiSelect(id, selectedList)
                      }
                    />
                    <div className="form-description">
                      <p>
                        Choose labels to help define your listing. Maximum of 3.
                      </p>
                    </div>
                  </div>

                  <div className="form-item file_upload-field">
                    <label>Cover Image</label>
                    <input
                      name="cover_img"
                      type="file"
                      onChange={this.handleImg}
                    />
                    <div className="file_desc">
                      {/* <p>Maximum file size: 8 MB.</p> */}
                      <p>
                        Supply your own or choose from 1 of our cover banners by{" "}
                        <a
                          href="https://coacherly.com/media/"
                          target="_blank"
                          className="darkLink"
                        >
                          clicking here
                        </a>{" "}
                        . Place the focus of the image in the centre and it
                        shouldn’t have any writing. Size 1400x600px
                      </p>
                    </div>
                    <img
                      key={listingData.cover_img}
                      className="md:ml-48 max-w-sm my-5"
                      src={listingData.cover_img}
                    />
                  </div>

                  <div className="form-item file_upload-field">
                    <label>Gallery images</label>
                    {/* <input
                      name="gallery_images"
                      type="file"
                      onChange={this.handleImg}
                      multiple
                    />
                    <div className="file_desc">
                      <p>Maximum file size: 8 MB.</p>
                    </div> */}
                    <Dropzone onDrop={this.onDrop} maxFiles={10}>
                      {({ getRootProps, getInputProps }) => (
                        <section className="container">
                          <div {...getRootProps({ className: "dropzone" })}>
                            <input {...getInputProps()} />
                            <p>
                              Drag 'n' drop some files here, or click to select
                              files
                            </p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                  </div>
                  <div className="listing__gallery">
                    <ul className="gallery__images flex">
                      {listingData.gallery_images.map((src, i) => {
                        return (
                          <Fragment key={i}>
                            <li>
                              <a
                                className="remove-image"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.removeGallery(src)}
                              >
                                &#215;
                              </a>
                              <img src={src} key={i} />
                            </li>
                          </Fragment>
                        );
                      })}
                    </ul>
                  </div>

                  {/*<div className="form-item">
                    <div className="form-label">Website (optional) : </div>
                    <input
                      className={
                        errClass == "listing_name"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="url"
                      name="website"
                      placeholder="https://www.example.com"
                      onChange={this.handleChange}
                      value={listingData.website}
                      autoComplete="off"
                      className={
                        errClass == "website"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                    />
                    </div>*/}
                  {/*<div className="form-item">
                    <div className="form-label">Phone Number : (optional)</div>
                    <input
                      className={
                        errClass == "listing_name"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="number"
                      name="phone"
                      placeholder="Phone Number"
                      onChange={this.handleChange}
                      value={listingData.phone}
                      autoComplete="off"
                      className={
                        errClass == "phone"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                    />
  </div>*/}

                  <div className="form-item">
                    <div className="form-label">Video : (optional)</div>
                    <input
                      className={
                        errClass == "video_url"
                          ? "border-red-500"
                          : "border-color-blue"
                      }
                      type="url"
                      name="video_url"
                      placeholder="Add link to a video about yourself or your services e.g., YouTube"
                      onChange={this.handleChange}
                      value={listingData.video_url}
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-item file_upload-field">
                    <label>Insurance Certificate (optional) </label>
                    <input
                      name="insurance_certificate"
                      type="file"
                      onChange={this.handleAttachment}
                    />
                    <div className="file_desc">
                      <p>Maximum file size: 8 MB.</p>
                    </div>
                    <img
                      key={listingData.insurance_certificate}
                      className="md:ml-48 max-w-sm my-5"
                      src={listingData.insurance_certificate}
                    />
                  </div>
                  <div className="form-item file_upload-field">
                    <label>Business Certificate (optional)</label>
                    <input
                      name="business_certificate"
                      type="file"
                      onChange={this.handleAttachment}
                    />
                    <div className="file_desc">
                      <p>Maximum file size: 8 MB.</p>
                    </div>
                    <img
                      key={listingData.business_certificate}
                      className="md:ml-48 max-w-sm my-5"
                      src={listingData.business_certificate}
                    />
                  </div>
                  <div className="form-item terms">
                    <div className="form-item--checkbox">
                      <input
                        type="checkbox"
                        id="coach-terms"
                        value={termAndCondtions}
                        onChange={(e) =>
                          this.setState({ termAndCondtions: e.target.checked })
                        }
                      />
                      <label
                        className="coach-terms-check"
                        htmlFor="coach-terms"
                      >
                        <p>
                          {" "}
                          I have read and accept the{" "}
                          <Link to="/terms-and-conditions" target="_blank">
                            Terms and Conditions
                          </Link>
                          ,{" "}
                          <Link to="/privacy-policy" target="_blank">
                            Privacy Policy
                          </Link>{" "}
                          and the{" "}
                          <Link to="/coach-contract">Coach Contract</Link>.
                        </p>
                      </label>
                    </div>
                  </div>
                  <div className="form-grid">
                    <div className="form-actions">
                      <button type="submit">
                        {addListingSpinner ? <LoadingSpinner /> : "Add Listing"}
                      </button>
                      <button
                        type="button"
                        onClick={(e) => this.showPreview(e)}
                      >
                        Preview
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AddListingsView;



// WEBPACK FOOTER //
// ./src/routes/AddListings/components/AddListingsView.js